import { ObservabilityPlugin } from '@module-federation/observability-plugin'
import { reportMfObservability } from './mf-observability'

// Runs in the browser. It is registered through `runtimePlugins` in
// webpack/module-federation.config.ts, so it is bundled into the synchronous federation runtime chunk.
const mfObservabilityRuntimePlugin = () =>
	ObservabilityPlugin({
		level: 'summary',
		browser: { mode: 'production' },
		onReport: (report) => {
			import('@persuit/ui-logger')
				.then(({ logger }) => reportMfObservability(logger, report))
				.catch((error: unknown) => {
					console.error('Module Federation report could not be logged', error, report)
				})
		},
	})

export default mfObservabilityRuntimePlugin
